// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { CustomerTriageStatus } from '@/customer/api/triage-types';
import { z } from 'zod';

export const triageCustomerSearchListingSchema = z.object({
  status: z.enum(['all', 'matched', 'dismissed']).optional(),
  page: z.number().optional(),
});

export type TriageCustomerSearchListing = z.infer<
  typeof triageCustomerSearchListingSchema
>;

export function getTriageCustomerStatusFromSearch(
  status?: 'all' | 'matched' | 'dismissed'
): CustomerTriageStatus {
  if (status === 'all') {
    return 'all';
  }
  if (status === 'matched') {
    return 'MATCHED';
  }
  if (status === 'dismissed') {
    return 'DISMISSED';
  }
  return 'NEEDS_REVIEW';
}
